<div class="app-modal-form">
  <div class="modal-topbar">
    <h5 class="modal-title" translate>ATTACHMENTS.UPLOAD_PRICE_LIST</h5>
    <div class="modal-actions">
      <button pButton type="button" icon="pi pi-window-maximize"
              class="p-button-text p-button-rounded p-button-plain"
              onclick="const d=this.closest('.p-dialog'); if(d){d.classList.toggle('app-dialog-maximized');}"></button>
      <button pButton type="button" icon="pi pi-times"
              class="p-button-text p-button-rounded p-button-plain"
              (click)="closeModal()"></button>
    </div>
  </div>
<p-fileUpload name="file"
              [customUpload]="true"
              (uploadHandler)="onFileUpload($event)"
              chooseLabel="{{ 'ATTACHMENTS.UPLOAD_PRICE_LIST' | translate }}"
              uploadLabel="{{ 'ACTIONS.UPLOAD' | translate }}"
              cancelLabel="{{ 'ACTIONS.CANCEL' | translate }}"
              multiple="false"
              maxFileSize="10000000"
              accept=".xlsx,.xls"
              class="mb-3">
</p-fileUpload>
</div>
